<template>
  <section
    ref="section26"
    class="mx-auto flex  h-full flex-col"
  >
    <v-add-listing-head
      :routes="routes"
      :step="31"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
        <figure class="flex gap-3">
          <div><v-icon icon="hand-wave" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mb-3 text-heading-3-desktop">
              Do objave vas loči še en korak
            </div>
            <div class="text-body-regular text-black-40">
              Oglejte si kako bodo vaš oglas videli potencialni kupci.
            </div>
          </div>
        </figure>
      </figure>
      <form method="POST" :action="routes.submitForm" id="select-preview">
        <v-csrf-token></v-csrf-token>
      </form>
    </main>
    <v-add-listing-foot>
      <a @click="submitForm('select-preview')"
       class="button button--md h-[48px] w-[240px] px-6">
        <label class="text-small-text-medium">Objavite oglas</label>
        <v-icon icon="circle-check" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    submitForm(formId) {
        document.getElementById(formId).submit();
    },
  },
};
</script>
